import { Component } from '@angular/core';
import { AuthStore } from '../../store/auth.store';

@Component({
  selector: 'pxl-user-menu',
  standalone: false,
  template: `
    <div
      class="pxl-avatar"
      [matTooltip]="'Welcome: ' + store.userName()"
      mat-button
      [matMenuTriggerFor]="menu"
    >
      <img [src]="store.userPhoto()" alt="User Avatar" />
    </div>
    <mat-menu #menu="matMenu" class="pxl-menu">
      @if(store.isSuperAdmin()) {
      <a mat-menu-item [routerLink]="['/', 'auth', 'users']">
        <mat-icon>group</mat-icon>
        <span>Users</span>
      </a>
      <button mat-menu-item (click)="store.sendInvite()">
        <mat-icon>send</mat-icon>
        <span>Invite User</span>
      </button>
      <mat-divider></mat-divider>
      }
      <button mat-menu-item (click)="store.logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  `,
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent {
  constructor(public store: AuthStore) {}
}
